import { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom"
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

const NAME_REGEX = /^[A-Za-z][A-Za-z0-9_.\s-]{5,29}$/;
const phoneNumberIsValid = (s) => {
    const numbersOnly = ("" + s).replace(/[^0-9]/g, "");
    const PHONE_REGEX = /^[0-9]{10}$/;
    return PHONE_REGEX.test(numbersOnly);
}
const formatPhoneNumber = (s) => {
    if (phoneNumberIsValid(s)) {
        const numbersOnly = ("" + s).replace(/[^0-9]/g, "");
        const match = numbersOnly.match(/^(\d{3})(\d{3})(\d{4})$/);
        return `(${match[1]}) ${match[2]}-${match[3]}`;
    } else {
        return s;
    }
}

const Account = () => {

    const axiosPrivate = useAxiosPrivate();

    const navigate = useNavigate();
    const location = useLocation();

    const [name, setName] = useState('');
    const [newName, setNewName] = useState('');
    const [validNewName, setValidNewName] = useState(false);

    const [phone, setPhone] = useState('');
    const [newPhone, setNewPhone] = useState('');
    const [validNewPhone, setValidNewPhone] = useState(false);

    const [verifiedPhone, setVerifiedPhone] = useState(false); // eslint-disable-line no-unused-vars

    const [email, setEmail] = useState('');

    const [firm, setFirm] = useState('');
    const [newFirm, setNewFirm] = useState('');

    const [disabledButton, setDisabledButton] = useState(true);

    const [alertStatus, setAlertStatus] = useState({
        open: false
    });


    // const [state, dispatch] = useReducer(reducer, {
    //     questions: [],
    //     dataLoaded: false
    // });

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setAlertStatus((prev) => {
            return { ...prev, open: false }
        });
    };

    useEffect(() => {
        setValidNewName(NAME_REGEX.test(newName));
    }, [newName])

    useEffect(() => {
        setValidNewPhone(phoneNumberIsValid(newPhone));
    }, [newPhone])

    // useEffect(() => {
    //     setDisabledButton(!(validNewName && validNewPhone && ((newName !== name) || (newFirm !== firm) || (formatPhoneNumber(newPhone) !== formatPhoneNumber(phone)))));
    // }, [validNewName, validNewPhone, newPhone, phone, newName, name, newFirm, firm]);

    useEffect(() => {
        setDisabledButton(!(validNewName && ((newName !== name) || (newFirm !== firm))));
    }, [validNewName, newName, name, newFirm, firm]);

    useEffect(() => {

        let isMounted = true;
        const controller = new AbortController();

        const getUser = async () => {
            try {
                const response = await axiosPrivate.get('/profile', {
                    signal: controller.signal
                });
                // console.log(`isMounted: ${isMounted}`);
                // console.log(response.data);
                if (isMounted) {
                    setName(response.data.name);
                    setNewName(response.data.name);
                    setEmail(response.data.email);
                    setPhone(response.data.phone || '');
                    setNewPhone(response.data.phone || '');
                    setVerifiedPhone(response.data.phone_verified || false);

                    setFirm(response.data.firm || '');
                    setNewFirm(response.data.firm || '');

                }
            } catch (err) {
                if (isMounted) {
                    console.error(err);
                    if (err.response?.status === 403) {
                        navigate('/login', { state: { from: location }, replace: true });
                    }
                }
            }
        }

        getUser();

        return () => {
            isMounted = false;
            controller.abort();
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const handleSubmit = async (e) => {
        e.preventDefault();
        let data = {};
        let update = false;
        if (newName !== name) {
            data.newName = newName;
            update = true;
        }
        if (newPhone !== phone) {
            data.newPhone = newPhone;
            update = true;
        }
        if (newFirm !== firm) {
            data.newFirm = newFirm;
            update = true;
        }
        console.log(`newFirm: ${newFirm} firm: ${firm}`);
        console.log(data);
        if (update) {
            try {
                const response = await axiosPrivate.put('/profile',
                    JSON.stringify(data),
                    {
                        headers: { 'Content-Type': 'application/json' },
                        withCredentials: true
                    }
                );
                console.log(response?.data);
                setName(response.data.name);
                setNewName(response.data.name);
                setPhone(response.data.phone || '');
                setNewPhone(response.data.phone || '');
                setVerifiedPhone(response.data.phone_verified || false);
                setFirm(response.data.firm || '');
                setNewFirm(response.data.firm || '');

                setAlertStatus({
                    open: true,
                    severity: "success",
                    message: "Successfully updated account"
                });

            } catch (err) {
                console.log(err);
                if (err.response?.status === 403) {
                    navigate('/login');
                }
                let message;
                if (!err?.response) {
                    message = 'No Server Response';
                } else if (err.response?.status === 404) {
                    message = 'Could not update profile';
                } else {
                    message = 'Unknown error';
                }
                setAlertStatus({
                    open: true,
                    severity: "error",
                    message: message
                });
            }
        }

    }

    return (
        <section>
            <h1>Account Info</h1>
            <form onSubmit={handleSubmit}>
                <label htmlFor="newName">Name:</label>
                <input
                    type="text"
                    id="newName"
                    className={(validNewName || (newName === "")) ? "" : "invalid"}
                    autoComplete="off"
                    onChange={(e) => setNewName(e.target.value)}
                    value={newName}
                    required
                    maxLength={50}
                    aria-invalid={validNewName ? "false" : "true"}
                />
                <label htmlFor="email">Email:</label>
                <input
                    type="email"
                    id="email"
                    autoComplete="off"
                    value={email}
                    maxLength={50}
                    readOnly
                />
                {/* <label htmlFor="newPhone">Phone{verifiedPhone ? ' (verified)' : ''}:</label>
                <input
                    type="text"
                    id="newPhone"
                    className={(validNewPhone || (newPhone === "")) ? "" : "invalid"}
                    onChange={(e) => setNewPhone(e.target.value)}
                    value={newPhone}
                    aria-invalid={validNewPhone ? "false" : "true"}
                    onBlur={(e) => setNewPhone(formatPhoneNumber(e.target.value))}
                />
                {(!verifiedPhone && phoneNumberIsValid(phone)) && <Link to="/verifyPhone">Verify phone</Link>} */}
                <label htmlFor="newFirm">Firm:</label>
                <input
                    type="text"
                    id="newFirm"
                    autoComplete="off"
                    onChange={(e) => setNewFirm(e.target.value)}
                    maxLength={50}
                    value={newFirm}
                />
                <button disabled={disabledButton}>Update account info</button>
            </form>
            <nav>
                <Link to="/">Home</Link>
            </nav>
            <Snackbar open={alertStatus.open} autoHideDuration={6000} onClose={handleClose}>
                <Alert onClose={handleClose} variant="filled" severity={alertStatus.severity} sx={{ width: '100%' }}>{alertStatus.message}</Alert>
            </Snackbar>
        </section>
    )
}

export default Account
